import * as React from "react";
const HaircutMale1 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 30 1080 1880">
		<title>{"coiffure m 1"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffures">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M639.66,139c0-6.43-15-34.31-32.17-45s-45-10.72-45-10.72-27.88,0-45,10.72-32.16,38.6-32.16,45-2.15,45,4.29,55.76,4.28,19.3,8.57,23.59,6.44,4.29,6.44,4.29-2.15-27.88,0-32.17,0-36.45,2.14-40.74,2.15-6.44,8.58-10.73,27.88-10.72,47.18-10.72,40.74,6.44,47.17,10.72,6.44,6.44,8.58,10.73,0,36.45,2.15,40.74,0,32.17,0,32.17,2.14,0,6.43-4.29,2.14-12.87,8.58-23.59S639.66,145.48,639.66,139Z"
			/>
		</g>
	</svg>
);
export default HaircutMale1;
